import React, {useContext, useState} from 'react';
import cancel from "../../accets/img/cancel.png";
import good from "../../accets/img/Good.png";
import comment from "../../accets/img/comment.png";
import paper_clip from "../../accets/img/paper_clip.png";
import {Context} from "../../index";
import {useNavigate} from "react-router-dom";

const CreatedMyTaskTabClose = ({TaskWithFileAndComment, date, catTab, statusTask}) => {

    const {userStore} = useContext(Context)
    const navigate = useNavigate()


    return (
        <div className={catTab === 2 && statusTask === 2 ? "one__tasks__block__cat__tab__active" : "one__tasks__block__cat__tab"}>

            {TaskWithFileAndComment.filter(i => i.userId === userStore.user.id && i.status === "CLOSE")
                .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                .map(task =>
                    <div key={task.id}
                         className="task"
                         onClick={() => navigate(`/job/task/${task.id}`)}
                    >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div
                                className={`date__block ${task.priority === 1 ? 'date__block__p1' : ''} ${task.priority === 2 ? 'date__block__p2' : ''} ${task.priority === 3 ? 'date__block__p3' : ''} ${task.priority === 4 ? 'date__block__p4' : ''}`}
                            >
                                <div className="num__block">{task.id}</div>
                                <div className="date__block">{date.format(Date.parse(task.createdAt))}</div>
                            </div>
                            {!task.name
                                ?
                                <div className="name__task">Без наименования</div>
                                :
                                <div className="name__task">{task.name}</div>
                            }
                        </div>
                        <div>
                            <div className="com__block">
                                {task.statement.filter(s => s.status === "NO").map(j =>
                                    <div key={j.id} className="com">
                                        <img src={cancel} alt={cancel}/>
                                    </div>
                                )

                                }
                                {task.statement.filter(s => s.status === "YES").map(j =>
                                    <div key={j.id} className="com">
                                        <img src={good} alt={good}/>
                                    </div>
                                )

                                }

                                {task.comment.length
                                    ?
                                    <div className="com">
                                        <img src={comment} alt={comment}/>
                                        <div className="com__num">{task.comment.length}</div>
                                    </div>
                                    : null
                                }

                                {task.fileto.length
                                    ?
                                    <div className="paper__clip">
                                        <img src={paper_clip} alt={paper_clip}/>
                                    </div>
                                    : null
                                }

                            </div>
                        </div>

                    </div>
                )}
        </div>
    );
};

export default CreatedMyTaskTabClose;